import Util from '@/util'

const MESSAGE_TYPES = {
  QUESTION_AND_ANSWER: 'question-and-answer',
}

const ACTIONS = {
  CREATE: 'create',
  VOTE: 'vote',
  QUESTION_UPDATED: 'question-updated',
}

function handleCreateQuestion(doc, rootComponent) {
  if (rootComponent.audienceId == doc.data.audience) {
    doc.data.voted = true
    const arr = JSON.parse(JSON.stringify(rootComponent.$store.state.questions))
    arr.push(doc.data)
    Util.updateDataQuestionAnswer(
      arr,
      rootComponent.$store.state.tabQnaQuestion,
    )
  } else if (rootComponent.$store.state.presentation.qnaAudienceShowAll) {
    if (rootComponent.$store.state.tabQnaQuestion == 2) {
      rootComponent.$store.state.questions.unshift(doc.data)
    } else {
      rootComponent.$store.state.questions.push(doc.data)
    }
  }
}

function handleVoteQuestion(doc, rootComponent) {
  rootComponent._updateQuestionAnswer(doc.data)
}

function handleUpdateQuestion(doc, rootComponent) {
  rootComponent._updateQuestionAnswer(doc.data)
}

const actionHandlers = {
  [ACTIONS.CREATE]: handleCreateQuestion,
  [ACTIONS.VOTE]: handleVoteQuestion,
  [ACTIONS.QUESTION_UPDATED]: handleUpdateQuestion,
}

function handleQuestionAndAnswer(doc, rootComponent) {
  const actionHandler = actionHandlers[doc.action]
  if (actionHandler && typeof actionHandler === 'function') {
    actionHandler(doc, rootComponent)
  }
}

const QuestionWebSocketSubscriber = {
  [MESSAGE_TYPES.QUESTION_AND_ANSWER]: handleQuestionAndAnswer,
}

export default QuestionWebSocketSubscriber
